// extracted by mini-css-extract-plugin
export default {"searchBox":"SearchBox_searchBox__Gs4aO","searchBox_input":"SearchBox_searchBox_input__XfLzU"};